<template>
  <asd20-modal
    v-if="person"
    :open="open"
    title="Staff Details"
    icon="staff"
    dismissable
    class="asd20-person-modal"
    @dismiss="$emit('dismiss')"
  >
    <header class="asd20-person-modal__header">
      <div class="asd20-person-modal__photo">
        <div class="photo">
          <img
            v-if="person.thumbnailUrl"
            :src="person.thumbnailUrl"
            :alt="person.displayName"
          />
        </div>
        <div class="initials">{{ initials }}</div>
      </div>
      <h2 class="name">{{ person.displayName }}</h2>
      <h3 class="title">{{ person.jobTitles.join(', ') }}</h3>
    </header>
    <Asd20Viewport class="asd20-person-modal__details" scrollable>
      <Asd20List>
        <Asd20ListItem
          v-show="person.office"
          icon="map"
          icon-size="lg"
          label="Office"
          :description="person.office"
        />

        <Asd20ListItem
          v-show="!person.office && person.organization"
          icon="map"
          icon-size="lg"
          label="Location"
          :description="person.organization"
        />
        <Asd20ListItem
          v-show="person.email && useEmailForm"
          icon="email"
          icon-size="lg"
          label="Send an Email"
          actionable
          @click.native="composingEmail = true"
        />
        <Asd20ListItem
          v-show="person.email && !useEmailForm"
          icon="email"
          icon-size="lg"
          label="Email"
          :description="
            `<a href='mailto:${person.email.replace(
              'mailto:',
              ''
            )}'>${person.email.replace('mailto:', '')}</a>`
          "
        />

        <Asd20ListItem
          v-show="person.workPhone"
          icon="phone-alt"
          icon-size="lg"
          label="Phone"
          :description="
            `<a href='tel:${person.workPhone}'>${person.workPhone}</a>`
          "
        />
        <div v-show="person.biography" class="asd20-person-modal__bio">
          <h3>About {{ person.displayName }}</h3>
          <div v-html="person.biography"></div>
        </div>
      </Asd20List>
    </Asd20Viewport>
    <asd20-compose-email-modal
      v-show="person"
      :open="open && composingEmail"
      :recipient-id="person.id"
      @dismiss="composingEmail = false"
    />
  </asd20-modal>
</template>

<script>
import Asd20Modal from '../../molecules/Asd20Modal'
import Asd20ComposeEmailModal from '../../organisms/Asd20ComposeEmailModal'
import Asd20List from '../../organisms/Asd20List'
import Asd20ListItem from '../../molecules/Asd20ListItem'
import Asd20Viewport from '../../atoms/Asd20Viewport'
import openMap from '../../../helpers/open-map'

export default {
  name: 'Asd20PersonModal',
  components: {
    Asd20Modal,
    Asd20ComposeEmailModal,
    Asd20List,
    Asd20ListItem,
    Asd20Viewport,
  },
  props: {
    person: { type: Object, default: null },
    open: { type: Boolean, default: false },
    forceDisplayEmail: { type: Boolean, default: false },
  },
  data: () => ({
    composingEmail: false,
  }),
  computed: {
    initials() {
      if (!this.person.displayName) return ''
      return this.person.displayName
        .split(' ')
        .map(n => n[0])
        .join('')
    },
    useEmailForm() {
      return (
        this.person.email &&
        this.person.email.indexOf('mailto:') === -1 &&
        !this.forceDisplayEmail
      )
    },
  },

  methods: {
    openMap,
  },
}
</script>

<style lang="scss" scoped>
@import '../../../design/_mixins.scss';
@import '../../../design/_variables.scss';

.asd20-person-modal {
  --accent-color: var(--color__secondary-t40);

  &__header {
    // background: var(--website-page__alternate-background-t50);
    // border-top: space(4.5) solid var(--color__accent);
    flex-shrink: 0;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    &::before {
      content: '';
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: space(5);
      background-color: var(--accent-color);
      background-image: url('/statics/images/chalk.png');
      background-position-y: top;
      background-size: 640px auto;
    }
    .name {
      font-size: 1.5rem;
      color: var(--color__primary);
      text-align: center;
      margin: 0 space(2);
      line-height: 1.1;
      margin-bottom: 0;
    }
    .title {
      font-size: 1.25rem;
      color: var(--accent-color);
      text-align: center;
      margin: 0 space(2);
      line-height: 1.1;
      // margin-bottom: space(1);
    }
  }
  &__photo {
    position: relative;
    z-index: 1;
    margin-top: space(1);
    background: var(--website-card__reverse-background-color)
      var(--website-card__reverse-background-style);
    color: var(--website-card__reverse-foreground-color);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 8rem;
    height: 8rem;
    margin-bottom: space(1);
    border-radius: 2px;
    font-size: 3rem;
    font-family: 'montserrat', sans-serrif;
    font-weight: 700;
    border-radius: var(--website-shape__radius-s);
    small {
      color: var(--website-page__alternate-background-color);
    }
    img {
      max-width: 8rem;
      display: block;
    }
    .photo {
      z-index: 10;
    }
    .initials {
      overflow: hidden;
      position: absolute;
    }
  }
  &__details {
    // padding: space(1);
  }
  .tags {
    display: flex;
    width: 100%;
    * {
      margin-right: space(0.125);
      margin-bottom: space(0.125);
    }
  }
  &__bio {
    padding: space(1);
    h3 {
      font-size: 1.25rem;
      color: var(--color__primary);
    }
  }
}
@media (min-width: 1024px) {
  ::v-deep .asd20-email-modal {
    .asd20-modal__content {
      padding: space(1);
    }

    .asd20-modal {
      margin-top: auto;
      margin-bottom: auto;
      max-width: 30vw;
    }
  }
  .asd20-person-modal {
    &::v-deep .asd20-modal {
      margin-top: auto;
      margin-bottom: auto;
      max-width: 40vw;
    }
    &__photo {
      width: 8rem;
      height: 8rem;
      img {
        max-width: 8rem;
      }
    }
    &__details {
      padding: space(1);
    }
  }
}
</style>
